import styled from '@emotion/styled';

export const StyledContent = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;
